<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="房间" property="roomId">
									<el-cascader
										placeholder="请选择房间"
										:options="TreeData"
										v-model="searchForm.roomId"
										:props="{ value: 'id', label: 'name', children: 'children' }"
										filterable
										clearable
										ref="myCascader"
									>
									</el-cascader>
								</el-form-item>
								<el-form-item label="报表类型">
									<el-radio-group v-model="totalType" size="mini" @change="handleTotalTypeChange">
										<el-radio-button :label="1">日报表</el-radio-button>
										<el-radio-button :label="2">月报表</el-radio-button>
									</el-radio-group>
								</el-form-item>
								<el-form-item label="日期范围" property="dateRange">
									<span>
										<el-date-picker
											v-model="dateRange"
											:type="dateRangeType"
											align="right"
											:format="dateFormat"
											:value-format="dateValueFormat"
											unlink-panels
											range-separator="至"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											:picker-options="pickerOptions"
											@change="get_baobiao"
										/>
									</span>
								</el-form-item>
							</span>

							<div class="search-box-button search-button search_box_button_right">
							<el-button size="mini" type="primary" @click.native.prevent="get_baobiao">查 询</el-button>
							<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							</div>

						</el-form>
						</div>
						<hr class="search_border">
						<div class="search_tools_div">
						<div class="search_tools_text">交易列表
							<span style="margin-left: 15px">总条数： {{totalObj.totalCount ? totalObj.totalCount : 0 }}</span>
							<span style="margin-left: 15px">总用电量： {{totalObj.totalMoney ? totalObj.totalMoney : 0 }}</span>
						</div>
						<div class="search-tools">
							<el-button type="primary" @click="exportExcel">导出</el-button>
						</div>
					</div>


					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  :height="tableHeight"
					  border
					  stripe
					  @selection-change="handleSelectionChange">
						<el-table-column prop="index" type="index" label="序号" align="center" width="80"></el-table-column>
						<el-table-column prop="recordDate" label="时间" align="center"></el-table-column>
						<el-table-column prop="roomNo" label="房间" align="center">
							<template slot-scope="scope">
								{{`${scope.row.regionName}-${scope.row.buildingName}-${scope.row.roomNo}`}}
							</template>
						</el-table-column>
						<el-table-column prop="thisAmount" label="用电量" align="center"></el-table-column>
						<!-- <el-table-column
						  prop="icon"
						  fixed="right"
						  align="center"
						  label="操作">
							<template slot-scope="scope">
								<el-button v-if="scope.row.type != '充值'" type="text" @click="viewHandle(scope.row)">详情</el-button>
							</template>
						</el-table-column> -->

					</el-table>

					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[ 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>
		<!-- 查看入住人员、交易记录 -->
		<el-dialog
		  :title="dialog.title"
		  :visible.sync="dialog.dialogVisible"
		  width="70%"
		  top="10vh"
		  :before-close="handleCloseDialog"
		>
		  	<el-table
				ref="dialogTable"
				:data="dialog.tableData"
				:span-method="arraySpanMethod"
				tooltip-effect="dark"
				border
				stripe
			>
				<el-table-column prop="index" type="index" label="序号" align="center" width="80"></el-table-column>
				<el-table-column  prop="personName" label="姓名" show-overflow-tooltip align="center"></el-table-column>
				<el-table-column  prop="personNo" label="学号" align="center"></el-table-column>
				<el-table-column  prop="inBalance" label="扣前余额" align="center">
					<template slot-scope="scope">
						{{scope.row.inBalance ? parseFloat(scope.row.inBalance).toFixed(4) : 0}}
					</template>
				</el-table-column>
				<el-table-column  prop="all" label="总扣费" align="center">
					<template scope="scope">
						{{scope.row.dealMoney * dialog.total}}
					</template>
				</el-table-column>
				<el-table-column  prop="dealMoney" label="分摊扣费金额" align="center">
					<template slot-scope="scope">
						{{scope.row.dealMoney ? parseFloat(scope.row.dealMoney).toFixed(4) : 0}}
					</template>
				</el-table-column>
				<el-table-column  prop="outBalance" label="个人余额（元）" align="center">
					<template slot-scope="scope">
						{{scope.row.outBalance ? parseFloat(scope.row.outBalance).toFixed(4) : 0}}
					</template>
				</el-table-column>
			</el-table>

			<div slot="footer" class="dialog-footer" style="margin-top: 20px;text-align: center;">
				<el-button @click="handleCloseDialog">关 闭</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import { getTree } from '@/apis/orange'
import { getEnergyList, exportEnergyList } from '@/apis/baobiao'

export default {
	name: "Baobiaotj",	// 报表
	data() {
		return {
			loading: false,
			nowDate: '',
			totalType: 1,

			searchForm: {},
			dateRange: [],
			dateRangeMoren: [],		// 默认日期范围
			TreeData: [
				{id: 0, name: '数据加载中' }
			],
			delBtlStatu: true,

			total: 0,
			size: 20,
			current: 1,
			totalObj: {},

			dialog: {
				total: 0,
				// size: 10,
				// current: 1,

				title: '订单扣费详情',
				dialogVisible: false,
				getParams: {},
				dateRange: [],
				tableData: [],
			},

			tableData: [],

			permDialogVisible: false,
			permForm: {},
			defaultProps: {
				children: 'children',
				label: 'machineNum'
			},
			treeSelectLocationId: 0,
			selectedMachineInfo: '',

			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}]
			},
		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		},
		dateRangeType() {
			return this.totalType === 1 ? 'daterange' : 'monthrange'
		},
		dateFormat() {
			return this.totalType === 1 ? 'yyyy-MM-dd' : 'yyyy-MM'
		},
		dateValueFormat() {
			return this.totalType === 1 ? 'yyyy-MM-dd' : 'yyyy-MM'
		}
	},
	created() {
		this.setDefaultDateRange()
		this.get_baobiao()
		this.getLocationTree()
	},
	methods: {
		setDefaultDateRange() {
			let t = new Date()
			let year = t.getFullYear()
			let month = ('0' + (t.getMonth() + 1)).slice(-2)
			if (this.totalType === 1) {
				// 日报表：默认本月（本月1号到今天）
				let day = ('0' + t.getDate()).slice(-2)
				let startDate = year + '-' + month + '-01'
				let endDate = year + '-' + month + '-' + day
				this.nowDate = endDate
				this.dateRange = [startDate, endDate]
				this.dateRangeMoren = [startDate, endDate]
			} else {
				// 月报表：默认当年1月到当年本月
				let startDate = year + '-01'
				let endDate = year + '-' + month
				this.nowDate = endDate
				this.dateRange = [startDate, endDate]
				this.dateRangeMoren = [startDate, endDate]
			}
		},
		handleTotalTypeChange() {
			this.current = 1
			this.setDefaultDateRange()
			this.get_baobiao()
		},
		resetSearchForm() {
			this.current = 1
			this.searchForm = {}
			this.get_baobiao()
		},
		exportExcel() {
			const loading = this.$loading({
				text: '加载中...',
			});
			let searchObj = {}
			searchObj = JSON.parse(JSON.stringify(this.searchForm))
			if (searchObj.roomId && searchObj.roomId.length) {
				let room = searchObj.roomId[ searchObj.roomId.length - 1 ].toString()
				// let floo = searchObj.roomId[ searchObj.roomId.length - 2 ] ? searchObj.roomId[ searchObj.roomId.length - 2 ].toString() : false
				// searchObj.roomId = floo ? room.split(floo)[1] : room
				// if (floo) {
				// 	searchObj.roomLocationId = room.split(floo)[1]
				// } else if (room != 0) {
				// 	searchObj.roomLocationId = room
				// 	delete searchObj.roomId
				// }
				searchObj.roomLocationId = room
				delete searchObj.roomId
			} else {
				delete searchObj.roomId
			}
			exportEnergyList({...searchObj, totalType: this.totalType, beginDate: this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0],
					endDate: this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1]}).then(res => res.data).then(res => {
				loading.close()
				// console.log(res);
				if (res.code == 200) {
					if (res.data.length) {
						let excelData = res.data.map((it, index) => ({index: index + 1, recordDate: it.recordDate, room: `${it.regionName}-${it.buildingName}-${it.roomNo}`, thisAmount: it.thisAmount }))
                        this.getExcel(excelData)
					} else {
						this.$message({
							type: 'error',
							message: "没有可导数据"
						})
					}
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		getExcel(excelData) {
            var XLSX = require("xlsx");

            // 创建一个工作表
            const worksheet = XLSX.utils.json_to_sheet(excelData)
            // 创建一个新的工作簿
            const workbook = XLSX.utils.book_new()

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')
            // 改写表头   'sku', 'wlms', 'ddsl', 'shsl', 'jhy'
            XLSX.utils.sheet_add_aoa(worksheet, [['序号', '时间', '房间', '用电量']], { origin: 'A1' })
            XLSX.writeFileXLSX(workbook, `用量统计报表${this.nowDate}.xlsx`)
        },
		getLocationTree() {
			getTree().then(res => res.data).then(res => {
				this.TreeData = this.adjustCascaderData(res.data)
			})
		},
		adjustCascaderData(data) {
			return data.map(item => {
				if (item.children && item.children.length == 0) {
					delete item.children; // 删除空的 children 数组
				} else {
					item.children = this.adjustCascaderData(item.children);
				}
				return item;
			});
		},
		arraySpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex ===4) { // 只对第二列（Category）进行合并
				if (rowIndex === 0) {
				return {
					rowspan: this.getRowSpan(row.category),
					colspan: 1,
				};
				} else {
					const prevRow = this.dialog.tableData[rowIndex - 1];
					if (prevRow.category === row.category) {
						return {
							rowspan: 0,
							colspan: 0,
						};
					} else {
						return {
							rowspan: this.getRowSpan(row.category, rowIndex),
							colspan: 1,
						};
					}
				}
			}
		},
		getRowSpan(category, startIndex = 0) {
			let count = 0;
			for (let i = startIndex; i < this.dialog.tableData.length; i++) {
				if (this.dialog.tableData[i].category === category) {
				count++;
				} else {
				break;
				}
			}
			return count;
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;

			this.delBtlStatu = val.length == 0
		},

		handleSizeChange(val) {
			this.size = val
			this.get_baobiao()
		},
		handleCurrentChange(val) {
			this.current = val
			this.get_baobiao()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.editForm = {}
		},
		handleCloseDialog() {
			this.dialog.dialogVisible = false
		},
		get_baobiao() {
			this.loading = true
			let searchObj = {}
			searchObj = JSON.parse(JSON.stringify(this.searchForm))
			if (searchObj.roomId && searchObj.roomId.length) {
				let room = searchObj.roomId[ searchObj.roomId.length - 1 ].toString()
				// let floo = searchObj.roomId[ searchObj.roomId.length - 2 ] ? searchObj.roomId[ searchObj.roomId.length - 2 ].toString() : false
				// searchObj.roomId = floo ? room.split(floo)[1] : room
				// if (floo) {
				// 	searchObj.roomLocationId = room.split(floo)[1]
				// } else if (room != 0) {
				// 	searchObj.roomLocationId = room
				// }
				searchObj.roomLocationId = room
				delete searchObj.roomId
			} else {
				delete searchObj.roomId
			}
			getEnergyList({current: this.current, size: this.size, totalType: this.totalType, ...searchObj, beginDate: this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0],
					endDate: this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1]
			}).then(res => res.data).then(res => {
				this.loading = false
				this.tableData = res.data.records
				this.total = res.data.total
				this.totalObj = res.total
			})
		},

		viewHandle(row) {
			const loading = this.$loading({
				text: '加载中...',
			});
			this.dialog.title = `扣费详情（${row.roomAllName}  /  ${row.dealTime}）`
			getEnergyList({
				// current: this.dialog.current, size: this.dialog.size, 
				beginDate: this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0],
				endDate: this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1],
				orderId: row.orderId
			}).then(res => res.data).then(res => {
				this.dialog.dialogVisible = true
				loading.close()
				this.dialog.tableData = res.data.records
				this.dialog.total = res.data.total
				this.dialog.loading = false
			})
		},
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center; 
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}

</style>